export default "__VITE_ASSET__197ef256__"